import { applyMiddleware, compose, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import rootReducer from "./reducers";
import { tokenRefresh } from "./retry-action/actions";
import rootSaga from "./sagas";

const sagaMiddleware = createSagaMiddleware();
let previousPayloads = {};

const authMiddleware = store => next => action => {
  // console.log("🚀 ~ file: index.js:11 ~ authMiddleware ~ action:", action);
  // Check if it's a action and save its payload
  // const excludedSuffixes = ["SUCCESS", "RESET", "FAIL"];
  // const isValidAction = !excludedSuffixes.some(suffix =>
  //   action.type.includes(suffix)
  // );
  // if (isValidAction) {
  previousPayloads[action.type] = {
    ...action,
  };
  // }
  // Retry Action Unauthorized

  // Is error
  const errorMess = action?.payload?.message || action?.error?.message || "";
  const statusError = action?.payload?.status || action?.error?.status;
  // Is xml error when
  // method: "get",
  // responseType is Blob ...
  const errorObject = action?.payload || action?.error || "null";
  const isObjectEmpty = Object.keys(errorObject).length === 0;
  // Is action fail
  const isActionFail = action?.type?.includes("FAIL") ? true : false;
  // Is logout fail
  const isLogOutFail =
    action?.type?.includes("LOGIN_API_ERROR") &&
    action?.payload?.config?.url === "services/mscsm/user/logout";
  // console.log("🚀 ~ authMiddleware ~ isActionFail:", isActionFail)
  // console.log("🚀 ~ authMiddleware ~ isLogOutFail:", isLogOutFail)
  // console.log("🚀 ~ authMiddleware ~ statusError:", statusError)
  if (isLogOutFail) {
    return;
  }
  if (
    isActionFail &&
    (statusError === 401 || errorMess === "Unauthorized" || isObjectEmpty)
  ) {
    const actionTypeRetry = action?.type?.replace(/_FAIL$/, "");
    console.log("🚀 ---- START actionTypeRetry:", actionTypeRetry);
    console.log(
      "🚀 ~ file: index.js:36 ~ authMiddleware ~ previousPayloads:",
      previousPayloads
    );
    const payloadRetry = previousPayloads[actionTypeRetry];
    console.log(
      "🚀 ~ file: index.js:24 ~ authMiddleware ~ payloadRetry:",
      payloadRetry
    );
    console.log("🚀 ---- END actionTypeRetry:-----");
    store.dispatch(tokenRefresh(actionTypeRetry, payloadRetry));
  }

  // Continue with the action
  return next(action);
};

const composeEnhancers =
  window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"] || compose;

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware, authMiddleware))
);
sagaMiddleware.run(rootSaga);

export default store;
